import antlr4 from 'antlr4'
import onedeskFormulaLexer from '@onedesk/modules/core/formula/parser/generated/onedeskFormulaLexer'
import onedeskFormula from '@onedesk/modules/core/formula/parser/generated/onedeskFormula'
import { onedeskFormulaParserError } from '@onedesk/modules/core/formula/parser/errors'

/**
 * Attempts to parse an input string into a onedesk Formula. If it fails a
 * onedeskFormulaParserError will be raised.
 *
 * @param formula
 * @return {*} The resulting antlr4 parse tree of the formula
 */
export default function parseonedeskFormula(formula, throwOnError = true) {
  const chars = new antlr4.InputStream(formula)
  const lexer = new onedeskFormulaLexer(chars)
  const tokens = new antlr4.CommonTokenStream(lexer)
  const parser = new onedeskFormula(tokens)
  parser.removeErrorListeners()
  // noinspection JSUnusedLocalSymbols
  parser.addErrorListener({
    syntaxError: (recognizer, offendingSymbol, line, column, msg, err) => {
      if (throwOnError) {
        throw new onedeskFormulaParserError(offendingSymbol, line, column, msg)
      }
    },
  })
  parser.buildParseTrees = true
  return parser.root()
}

export function getTokenStreamForFormula(formula) {
  const chars = new antlr4.InputStream(formula)
  const lexer = new onedeskFormulaLexer(chars)
  const stream = new antlr4.CommonTokenStream(lexer)
  stream.lazyInit()
  stream.fill()
  return stream
}
